import React, { useState ,memo} from "react";
import { Text } from "react-internationalization";
import ChevronLeftSharpIcon from "@material-ui/icons/ChevronLeftSharp";
import ChevronRightSharpIcon from "@material-ui/icons/ChevronRightSharp";
const StepperSidebar = memo((props) => {
  const [show, setShow] = useState(true);
  const toggle=()=>{
    // console.log("show",show)
    setShow(!show)
    // props.setSideBar(!show)
  }
  return (
    <>
      {show === true ? (
        <div className="sidebar sidebar-min-width">
          {console.log("stepper",props.agentLogin)}
        <div className="stepper-container" id="stepper">
          <div className="sidebar-brand-bg">
            <p class="sidebar-search-heading">Enrollment Form</p>
            <a
              className="btn btn-sidebaricon rounded-circle display-flex float-right mr-1 mt-2"
              onClick={toggle}
            >
              <ChevronLeftSharpIcon
                className="toggle-icon-color"
                onClick={toggle}
              />
            </a>
          </div>
          <ul
            class="display-block stepper-alligner"
            value={props.stepVal}
            
          >
            {props.agentLogin === true &&
              props.productName !== "Medicare Supplement" && (
                <li className="side-step">
                  <span
                    class={
                      props.stepVal === "step0"
                        ? "side-step-number step-selected"
                        : "side-step-number"
                    }
                    data-toggle="tab"
                    id="step0"
                    onClick={props.handleSteps}
                  >
                    0
                  </span>
                  <span className="side-step-text">
                    <Text id="app.soa1" />
                  </span>
                </li>
              )}
            <li className="side-step">
              <span
                className={
                  props.stepVal === "step1"
                    ? "side-step-number step-selected"
                    : "side-step-number"
                }
                data-toggle="tab"
                id="step1"
                onClick={props.handleSteps}
              >
                {/* {props.agentLogin === true?2: */}
                1
                {/* } */}
              </span>
              <span className="side-step-text"><Text id="app.perInfo"/></span>
            </li>
            <li className="side-step">
              <span
                className={
                  props.stepVal === "step2"
                    ? "side-step-number step-selected"
                    : "side-step-number"
                }
                data-toggle="tab"
                id="step2"
                onClick={props.handleSteps}
              >
                {/* {props.agentLogin === true?3: */}
                2
                {/* } */}
              </span>
              <span className="side-step-text"><Text id="app.attn"/></span>
            </li>
            <li className="side-step">
              <span
                className={
                  props.stepVal === "step3"
                    ? "side-step-number step-selected"
                    : "side-step-number"
                }
                data-toggle="tab"
                id="step3"
                onClick={props.handleSteps}
              >
                {/* {props.agentLogin === true?4: */}
                3
                {/* } */}
              </span>
              <span className="side-step-text"><Text id="app.otherDetail"/></span>
            </li>
            {props.agentLogin === true && (
              <li className="side-step">
                <span
                  className={
                    props.stepVal === "step4"
                      ? "side-step-number step-selected"
                      : "side-step-number"
                  }
                  data-toggle="tab"
                  id="step4"
                  onClick={props.handleSteps}
                >
                 {/* {props.agentLogin === true?5: */}
                 4
                 {/* } */}
                </span>
                <span className="side-step-text"><Text id="app.preview"/></span>
              </li>
            )}
            {props.agentLogin === true && (
              <li className="side-step">
                <span
                  className={
                    props.stepVal === "step5"
                      ? "side-step-number step-selected"
                      : "side-step-number"
                  }
                  data-toggle="tab"
                  id="step5"
                  onClick={props.handleSteps}
                >
                  {/* {props.agentLogin === true?6: */}
                  5
                  {/* } */}
                </span>
                <span className="side-step-text"><Text id="app.signature"/></span>
              </li>
            )}
          </ul>
        </div>
        </div>
      ) : (
        <a
          className="btn btn-sidebaricon-hide rounded-circle display-flex mobile-width"
          onClick={toggle}
          id="stepper"
        >
          <ChevronRightSharpIcon
            className="toggle-icon-color"
            onClick={toggle}
          />
        </a>
      )}
    </>
  );
});
export default StepperSidebar;
